module.exports = __webpack_public_path__ + "img/10.f8649892.png";